










import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { FeedProduct } from '../../models';

import EntityMap from '@/components/display/maps/entityMap.vue';
import { EntityLocation, FeedTank, Transceiver } from '@/api';
import { Constants } from '@/common/Constants';

@Component({
	components: {
		EntityMap,
	},
})
export default class FeedProductMapTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	public get feedTankLocations(): {
		entityType: string;
		location: EntityLocation;
		entity: FeedTank & {
			transceiver: Transceiver | null;
			entitylocation: EntityLocation | null;
		};
	}[] {
		return this.feedTanks
			.filter(feedTank => feedTank.entitylocation !== null)
			.map(feedTank => ({
				entityType: Constants.ENTITY_TYPE_FEED_TANK,
				location: feedTank.entitylocation!,
				entity: feedTank,
			}));
	}

	public get transceivers(): Transceiver[] {
		return this.feedTanks
			.filter(feedTank => feedTank.transceiver !== null)
			.map(feedTank => feedTank.transceiver!);
	}

	public get mapCenter(): { lat: number; lng: number } | null {
		if (
			this.feedProduct.site === null ||
			!this.feedProduct.site?.latitude ||
			!this.feedProduct.site.longitude
		) {
			return null;
		}
		return {
			lat: parseFloat(this.feedProduct.site.latitude),
			lng: parseFloat(this.feedProduct.site.longitude),
		};
	}

	private get feedTanks(): FeedTank &
		{
			transceiver: Transceiver | null;
			entitylocation: EntityLocation | null;
		}[] {
		return this.feedProduct.feedtanks;
	}
}
